import 'dayjs/locale/fr';
import React, {useCallback, useState} from 'react';
import {Linking, View} from 'react-native';
import {formatDateTo} from '../../../../../common/utils/functions';
import {Validation} from '../../../../../common/utils/validationSouscriptionScolaire';
import url from '../../../../../data/config';
import {TitleLabels} from '../../../../../data/constants/Assurance/assuranceScolaire';
import {
  handleGetCurrentDateEffet,
  thousandSeparator,
} from '../../../../../data/factory';
import {useForm} from '../../../../../hooks/AssuranceScolaire/useForm';
import SubmitButtons from '../../../../components/Button/SecondaryButton';
import CheckBoxComponent from '../../../../components/Inputs/Checkbox';
import {InputDatePicker} from '../../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../../components/Inputs/InputField';
import {InputPhoneNumber} from '../../../../components/Inputs/InputPhoneNumber';
import Select from '../../../../components/Inputs/Select';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Form = (props: any) => {
  const {
    data,
    listAgence,
    onCancelForm,
    onSubmitForm,
    prime,
    isRenewal,
    minDateEffect,
  } = props;

  const {handleChange, handleSubmit, values, errors, showErrors, dto} = useForm(
    data,
    Validation,
    handleCancel,
    handleSave,
    listAgence,
    prime,
  );

  function handleCancel() {
    onCancelForm();
  }
  const [isDisable, setIsDisable] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  function handleSave() {
    if (dto.data.dateNaissanceEleveAssure instanceof Date) {
      dto.data.dateNaissanceEleveAssure = formatDateTo(
        dto.data.dateNaissanceEleveAssure,
        'DD/MM/YYYY',
      );
    }
    dto.data.dateEffet = handleGetCurrentDateEffet(dto.data.dateEffet);
    dto.data.primeTTC = dto.data.primeTTC.split(' ').join('');
    onSubmitForm(dto.data);
  }

  const showTermsOfUse = useCallback(() => {
    Linking.openURL(url.scolairePdf);
  }, []);

  return (
    <View>
      {modalVisible && (
        <ConfirmationModal
          title={"Termes et condition d'utilisation"}
          btn1={'Fermer'}
          content={'hello scolaire'}
          handleBtn1={() => setModalVisible(false)}
        />
      )}
      <View>
        <InputField
          label={TitleLabels.contractant.nomPrenomContractant}
          required
          value={values.nomPrenomContractant}
          name="nomPrenomContractant"
          onChange={handleChange}
          error={errors.nomPrenomContractant}
          showError={showErrors.nomPrenomContractant}
          maxLength={70}
          isEditable={false}
        />
        <InputPhoneNumber
          label={TitleLabels.contractant.telephoneContractant}
          required
          name="telephoneContractant"
          type="telephone"
          value={values.telephoneContractant}
          onChange={handleChange}
          error={errors.telephoneContractant}
          showError={showErrors.telephoneContractant}
          isEditable={false}
          country={values?.telephoneContractantCountryCode || 'MG'}
        />
        <InputField
          label={TitleLabels.contractant.emailContractant}
          required
          name="emailContractant"
          value={values.emailContractant}
          onChange={handleChange}
          error={errors.emailContractant}
          showError={showErrors.emailContractant}
          maxLength={100}
          isEditable={false}
        />
        <InputField
          label={TitleLabels.contractant.dateNaissanceContractant}
          required
          name="dateNaissanceContractant"
          value={values.dateNaissanceContractant}
          onChange={handleChange}
          error={errors.dateNaissanceContractant}
          showError={showErrors.dateNaissanceContractant}
          maxLength={100}
          isEditable={false}
        />

        <InputField
          label={TitleLabels.eleveAssure.nomPrenomEleveAssure}
          required
          value={values.nomPrenomEleveAssure}
          name="nomPrenomEleveAssure"
          onChange={handleChange}
          error={errors.nomPrenomEleveAssure}
          showError={showErrors.nomPrenomEleveAssure}
          maxLength={70}
          isEditable={!isRenewal}
        />

        <InputDatePicker
          label={TitleLabels.eleveAssure.dateNaissanceEleveAssure}
          required
          value={values.dateNaissanceEleveAssure}
          name="dateNaissanceEleveAssure"
          onChange={handleChange}
          error={errors.dateNaissanceEleveAssure}
          showError={showErrors.dateNaissanceEleveAssure}
          dateMax={new Date()}
          isEditable={!isRenewal}
          noInit
        />
        <InputField
          label={TitleLabels.eleveAssure.etablissementScolaire}
          required
          name="etablissementScolaire"
          value={values.etablissementScolaire}
          onChange={handleChange}
          error={errors.etablissementScolaire}
          showError={showErrors.etablissementScolaire}
          maxLength={50}
        />
        <InputField
          label={TitleLabels.eleveAssure.anneeScolaire}
          required
          type="anneeScolaire"
          name="anneeScolaire"
          value={values.anneeScolaire}
          onChange={handleChange}
          error={errors.anneeScolaire}
          showError={showErrors.anneeScolaire}
          maxLength={50}
        />
        <InputField
          label={TitleLabels.contractant.adresse}
          required
          name="adresse"
          value={values.adresse}
          onChange={handleChange}
          error={errors.adresse}
          showError={showErrors.adresse}
          maxLength={50}
          isEditable={false}
        />
        <InputDatePicker
          label={TitleLabels.contractant.dateEffet}
          required
          value={values.dateEffet}
          name="dateEffet"
          onChange={handleChange}
          dateMin={minDateEffect}
          error={errors.dateEffet}
          showError={showErrors.dateEffet}
        />
        <Select
          data={
            listAgence.length
              ? [
                  {label: 'Choisir Agence', value: ''},
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ...listAgence.map((element: any) => ({
                    label: element.label,
                    value: element.value,
                  })),
                ]
              : []
          }
          label={TitleLabels.contractant.agence}
          defaultValue={values.agence}
          required={true}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
          onChange={(name: string, data: any, fired: boolean) => {
            handleChange('agence', data, true);
          }}
          value={values.agence}
          error={errors.agence}
          showError={showErrors.agence}
          disabled={isRenewal}
        />
        <InputField
          label={TitleLabels.contractant.primeTTC}
          type="price"
          isEditable={false}
          required
          name="primeTTC"
          value={thousandSeparator(values.primeTTC, '')}
          onChange={handleChange}
          error={errors.primeTTC}
          showError={showErrors.primeTTC}
        />
        <CheckBoxComponent
          changeValue={setIsDisable}
          value={isDisable}
          onPress={() => {
            console.log('click pdf');
            showTermsOfUse();
          }}
        />
      </View>
      <View style={{marginTop: -20, marginBottom: 50}}>
        <SubmitButtons
          isDisable={!isDisable}
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle="Valider"
        />
      </View>
    </View>
  );
};
